<template>
  <Button
    class="flex justify-center"
    variant="none">
    <IconBase
      class="mr-2"
      :size="IconSize.Medium">
      <Feedback />
    </IconBase>
    <slot />
  </Button>
</template>

<script setup lang="ts">
import {IconBase, Feedback, IconSize, Button} from '@myparcel-frontend/ui';
</script>
